// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"4f3784b8","511":"d65d2296"}[chunkId] + ".css";
};